import classNames from 'classnames';
import React from 'react';
import { CloseableModal } from '../CloseableModal';

interface PropTypes {
  title: JSX.Element | string;
  isOpen: boolean;
  onCancel(): void;
  bodyChildren: JSX.Element | string;
  bodyClassName?: string;
  contentClassName?: string;
  overflowVisible?: boolean;
  footerChildren?: JSX.Element;
  footerClassName?: string;
  external?: React.ReactNode;
  size: string;
}

export function StyledModal(props: PropTypes) {
  return (
    <CloseableModal
      className='justify-content-center'
      onClose={props.onCancel}
      isOpen={props.isOpen}
      size={props.size}
      external={props.external}
      headerChildren={<span className='fs-4 fw-bold'>{props.title}</span>}
      headerClassName={'bg-gray p-4'}
      bodyClassName={props.bodyClassName || 'p-4'}
      centered={true}
      contentClassName={classNames(
        props.overflowVisible === true ? 'overflow-visible' : 'overflow-hidden',
        'rounded-5',
        'w-80',
        props.contentClassName,
      )}
      bodyChildren={props.bodyChildren}
      closeButtonClassName='fs-6'
      footerChildren={props.footerChildren}
      footerClassName={classNames('p-0', props.footerClassName)}
    />
  );
}
